export default __webpack_public_path__ + "static/media/drypopup.5a162cff.mp3";